import { gql } from '@apollo/client/core';
import { catalogCardFragment } from './catalog-cards/catalog-card';

export const inlineBannerFragment = gql`
  fragment InlineBannerFragment on InlineBanner {
    description
    image {
      high
    }
    link
    id
  }
`;

export const extendableOfferFragment = gql`
  fragment ExtendableOfferFragment on ExtendableOffer {
    description
    id
    products(page: $page, size: $size) {
      ...CatalogCardFragment
      cardNearestDeliveryInfo(cityId: $cityId) {
        nearestDelivery
      }
    }
    title
    category {
      title
      id
    }
    adMarker {
      marker
      orgInn
      orgName
    }
  }
  ${catalogCardFragment}
`;

export const verticalOfferFragment = gql`
  fragment VerticalOfferFragment on VerticalOffer {
    id
    title
    category {
      id
    }
    content(offset: $offset, rowWidth: $rowWidth) {
      ... on CardBlock {
        content {
          ...CatalogCardFragment
          cardNearestDeliveryInfo(cityId: $cityId) {
            nearestDelivery
          }
        }
      }
      ... on CarouselOffer {
        id
        title
        category {
          id
          title
        }
        products(page: 0, size: $offerSize) {
          ...CatalogCardFragment
          cardNearestDeliveryInfo(cityId: $cityId) {
            nearestDelivery
          }
        }
        adMarker {
          marker
          orgInn
          orgName
        }
      }
      ... on ImageOffer {
        id
        image {
          high
        }
        title
        category {
          id
          title
        }
        products(page: 0, size: $offerSize) {
          ...CatalogCardFragment
          cardNearestDeliveryInfo(cityId: $cityId) {
            nearestDelivery
          }
        }
        adMarker {
          marker
          orgInn
          orgName
        }
      }
      ... on InlineBanner {
        ...InlineBannerFragment
      }
    }
  }
  ${catalogCardFragment}
  ${inlineBannerFragment}
`;
